import css from 'styled-jsx/css';

const styles = css`
  .skeleton-loading {
    min-height: 50px;
  }

  .skeleton-price-line {
    height: 24px;
    background-color: #f4f4f4;
    width: 80%;
    margin-bottom: 8px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
  }

  .short {
    width: 60%;
  }

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export default styles;
